import React, { useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'

const TaxForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_tax: data.id_tax,
        p_name_tax: data.name_tax,
        p_value_tax: data.value_tax
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_tax}
            onChange={e => setRow({ ...row, p_name_tax: e.currentTarget.value })}
            maxLength={150}
        />
        <Input
            text="Valor"
            placeholder="Valor"
            type="number"
            classNameParent="col-12 mb-2"
            icon="fas fa-dollar-sign"
            required
            invalid="El campo es obligatorio."
            min="0"
            step="0.0001"
            defaultValue={data.value_tax}
            onChange={e => setRow({ ...row, p_value_tax: e.currentTarget.value })}
        />
    </FormCustom>
}

TaxForm.defaultProps = {
    data: {
        id_tax: '',
        name_tax: '',
        value_tax: ''
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default TaxForm;